var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.8368C0 18.0619 0.0896205 18.278 0.248854 18.4374C0.408087 18.5966 0.624157 18.6861 0.849465 18.6861H16.988C17.2915 18.6861 17.5718 18.5241 17.7237 18.2613C17.8753 17.9985 17.8753 17.6748 17.7237 17.412C17.5718 17.1492 17.2915 16.9873 16.988 16.9873H0.849465C0.624149 16.9873 0.408078 17.0768 0.248854 17.2362C0.0896205 17.3954 0 17.6115 0 17.8368V17.8368Z",
    fill: "#52526C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91861 0C8.69346 0 8.47739 0.0894524 8.318 0.248686C8.15876 0.407919 8.06931 0.623989 8.06931 0.849297V12.5929L3.52588 8.69831C3.35639 8.54176 3.1304 8.46089 2.89987 8.47434C2.66951 8.48779 2.45444 8.59439 2.3043 8.76977C2.15414 8.94498 2.08184 9.17399 2.10404 9.4037C2.12623 9.63338 2.24091 9.84422 2.42166 9.98765L8.36751 15.0838V15.084C8.41308 15.1169 8.46167 15.1453 8.51279 15.1689C8.54322 15.1894 8.575 15.2079 8.60796 15.224C8.80755 15.3091 9.03336 15.3091 9.23297 15.224C9.26593 15.2079 9.29771 15.1894 9.32814 15.1689C9.37926 15.1453 9.42785 15.1169 9.47342 15.084L15.4193 9.98782V9.98765C15.6365 9.78688 15.7337 9.48759 15.6757 9.19755C15.6178 8.90733 15.413 8.66823 15.1353 8.56651C14.8575 8.46461 14.5467 8.51455 14.315 8.69834L9.76815 12.5929V0.849327C9.76815 0.624011 9.6787 0.40794 9.5193 0.248716C9.36007 0.0894826 9.144 3.02137e-05 8.91869 3.02137e-05L8.91861 0Z",
    fill: "#52526C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.abbd3d88389159c147304338ecdd9e68.svg";
export { ForwardRef as ReactComponent };